import { CyberPayLogModel, CyberPaySetTransactionResponse } from './../../model/CyberPay';
import { PaymentService } from './../../services/payment.service';
import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from "@angular/router";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cyber-pay-verify',
  templateUrl: './cyber-pay-verify.component.html',
  styleUrls: ['./cyber-pay-verify.component.css']
})
export class CyberPayVerifyComponent implements OnInit {

  reference : string;
  cyberpayRes : CyberPaySetTransactionResponse;

  constructor(private activatedRoute : ActivatedRoute, private paymentService : PaymentService) { }

  ngOnInit() {

    this.activatedRoute.queryParams.subscribe(params=>{
      this.reference = params['ref'];

      if(this.reference == undefined){
        //notify error
        //return
      }



      console.log(this.reference);
    });
  }

  RenewPlan(){
    
  }
  VerifyTransaction(reference){
    this.paymentService.cyberPayGetTransaction(reference).subscribe(res=>{

      if(!res.succeeded){
        //notify error
      }

      this.cyberpayRes = res;
      
      this.paymentService.LteHttpGetCyberpayRequestLog(reference).subscribe(res=>{
        let response : CyberPayLogModel = res.Result;

        if(!response.IsSuccessful){

            this.paymentService.LteCreditCustomer(environment.OperatorID,response.CustomerID,response.i_account,response.i_product,true, this.cyberpayRes).subscribe(res=>{

              response.IsSuccessful = true;
              response.Transaction_status = "SUCCESSFUL";

              this.paymentService.LteHttpUpdateLogCyberPayRequest(response).subscribe(res=>{

              })

            })
        }




      })
    })
  }

}
